import { apiKeys } from './../../utility/global-constants/authentication';

export const perfConfig = {
  name: 'perf',
  logging: {
    baseUrl: 'https://dev.core-gateway.np.api-business.comcast.com/logging-api/event',
    key: 'JKbf1AExxt9Hmim9OsZsC3zjAMsBzOog4jPRJFLD',
  },
  otlp: {
    endpoint: 'https://otlp-gateway.np.api-business.comcast.com:443/v1/traces',
    headers: {
      'x-api-key': 'JKbf1AExxt9Hmim9OsZsC3zjAMsBzOog4jPRJFLD',
    },
  },
  eSign: {
    baseUrl: 'https://perf.ecom-gateway.np.api-business.comcast.com/',
  },
  content: {
    baseUrl: 'https://content.ecom.np.digital.business.comcast.com',
  },
  myAccount: {
    baseUrl: 'https://business.stg.comcast.com/',
  },
  frictionLess: {
    baseUrl: '',
  },
  dataLayer: {
    src: 'https://static.cimcontent.net/data-layer/nonprod/datalayer-commercial-dtm.min.js?appId=busn_ecom',
  },
  signNow: {
    confirmation: {
      new: 'https://comcast--sfdcbrtfl--c.cs21.visual.force.com/apex/FT_FlexiQuote?id=<opp_id>&page=schedule',
      existing: 'https://brt2.np.fxbuyflow.business.comcast.com/sign-now/success?id=<opp_id>',
    },
    back: {
      new: 'https://comcast--sfdcbrtfl--c.cs21.visual.force.com/apex/FT_FlexiQuote?id=<opp_id>',
      existing: 'https://brt2.np.fxbuyflow.business.comcast.com/sign-now/reconfigure?id=<opp_id>',
    },
  },
  'api-key': apiKeys.preProd,
  serviceLoggingEnabled: true,
  initializeCall504DelayEnabled: true,
  updateCall504DelayEnabled: true
};
